const ENV = "aws"; // Default to 'development' if not set

let API_BASE_URL;
let API_BASE_URL_DECKLE;

switch (ENV) {
  case 'uat':
    API_BASE_URL = 'https://papyerpwebapi-uat.netiqueinfotech.com/api/Interface/';
    API_BASE_URL_DECKLE = 'https://devtrimweb-api.netiqueinfotech.com/WeatherForecast/';
    break;
  case 'aws':
    API_BASE_URL = 'https://papyerpwebapi.netiqueinfotech.com/api/Interface/';
    API_BASE_URL_DECKLE = 'https://devtrimweb-api.netiqueinfotech.com/WeatherForecast/';
    break;
  case 'sit':
    API_BASE_URL = 'https://papyerpwebapi-sit.netiqueinfotech.com/api/Interface/';
    API_BASE_URL_DECKLE = 'https://devtrimweb-api.netiqueinfotech.com/WeatherForecast/';
    break;
  case 'local':
    API_BASE_URL = 'http://localhost:5572/api/Interface/';
    API_BASE_URL_DECKLE = 'https://localhost:44334/WeatherForecast/';
    break;
  case 'trial':
    API_BASE_URL = 'https://papyerpwebapi-trial.netiqueinfotech.com/api/Interface/';
    API_BASE_URL_DECKLE = 'https://localhost:44334/WeatherForecast/';
    break;
  default:
    console.warn('Unknown environment:', ENV);
    API_BASE_URL = 'http://localhost:5572/api/Interface/';
    API_BASE_URL_DECKLE = 'https://localhost:44334/WeatherForecast/';
}

export const API_ENDPOINTS = {

  API_COMMAN_URL: API_BASE_URL,
  // SECURITY PROCESS
  SECUR_GET_CREDENTIALS: `${API_BASE_URL}getSecurityUserCredentials`,

  // DOCUMENT SEQUENCE
  PROD_MANAGEMENT_GET_DOCUMENT_SEQUENCE: `${API_BASE_URL}getSequenceNumberList`,
  PROD_MANAGEMENT_GET_DOCUMENT_SEQUENCE_DETAILS: `${API_BASE_URL}getSequenceNumberDetails`,
  PROD_MANAGEMENT_UPDATE_DOCUMENT_SEQUENCE_DETAILS: `${API_BASE_URL}updateSequenceNumberDetails`,

  // form employee
  Example_Employee_form: `${API_BASE_URL}employee-details`,
  CallEmployeeDetail: `${API_BASE_URL}employee-details`,

  // COMMON MASTERS
  PROD_MANAGEMENT_GET_SHIFT_CODE: `${API_BASE_URL}getShiftCodes`,
  PROD_MANAGEMENT_GET_OPERATOR: `${API_BASE_URL}getOperator`,
  PROD_MANAGEMENT_ADD_OPERATOR: `${API_BASE_URL}addOperator`,
  PROD_MANAGEMENT_GET_REJECTION_REASON: `${API_BASE_URL}production-rejection-reason`,
  PROD_MANAGEMENT_PRODUCT_REJECTION: `${API_BASE_URL}production-insert-reject-product-details`,
  PROD_MANAGEMENT_GET_CUTTER_CODE: `${API_BASE_URL}get-cutter-code`,
  PROD_MANAGEMENT_GET_SHIFT_BREAK_TYPE: `${API_BASE_URL}shift-break-crud`,
  PROD_MANAGEMENT_GET_SHIFT_CODE_STATUS: `${API_BASE_URL}shift-code-status`,

  // Deckle Matching Process
  DECKL_GETORDERITEMS: `${API_BASE_URL}orderselection`,
  DECKL_UPDATE_REJECT_REEL: `${API_BASE_URL}addrejectreason`,
  DECKL_ORDERLINEITEMS: `${API_BASE_URL}orderlineitems`,
  DECKL_LOADPARAMETERLIST: `${API_BASE_URL}getparameterlist`,
  DECKL_UPDATEPARAMETERLIST: `${API_BASE_URL}updateparameterlist`,
  DECKL_INSERT_MATCHING_RESULTS: `${API_BASE_URL}insert-decklematching-results`,
  DECKL_INSERT_MATCHING_GET_RESULTS: `${API_BASE_URL}get-decklematching-results`,

  DECKL_MATCHING_REFRESH_DATA: `${API_BASE_URL}deckle-matching-refresh-data`,
  DECKL_MATCHING_GET_MO_DETAILS: `${API_BASE_URL}get-decklematching-mo-details`,
  DECKL_MATCHING_GET_ACHIEVED_REELS: `${API_BASE_URL}get-decklematching-mo-achieved-reels`,
  DECKL_MATCHING_GET_COMBINATIONS: `${API_BASE_URL}get-decklematching-mo-combination`,
  DECKL_MATCHING_GET_GRAPHICAL_DATA: `${API_BASE_URL}get-decklematching-mo-graphical`,
  DECKL_MATCHING_GET_LINEITEMS_DET: `${API_BASE_URL}get-decklematching-mo-lineitemsdetail`,
  DECKL_MATCHING_GET_SIZE_WISE_DET: `${API_BASE_URL}get-decklematching-mo-sizewise-details`,
  DECKL_MATCHING_GET_SUMMARY_DET: `${API_BASE_URL}get-decklematching-mo-summarydata`,
  DECKL_MATCHING_GET_CUSTOMER_HDR: `${API_BASE_URL}get-decklematching-mo-customer-hdr`,
  DECKL_MATCHING_GET_CUSTOMER_DET: `${API_BASE_URL}get-decklematching-mo-customer-det`,

  DECKL_MATCHING_RELEASE_MO: `${API_BASE_URL}decklematching-release-mo`,
  DECKL_MATCHING_GET_MO_LIST: `${API_BASE_URL}mo-list-detail`,
  DECKL_MATCHING_MO_AMENT: `${API_BASE_URL}mo-ament-data`,
  DECKL_MATCHING_GET_SELECTED_MO_DETAILS: `${API_BASE_URL}get-selected-mo-details`,

  DECKL_MATCHING_GET_STANDARDSIZES: `${API_BASE_URL}decklematching-get-standardsizes`,
  DECKL_MATCHING_RUN_DECKLE: `${API_BASE_URL_DECKLE}DeckleMatchingRun`,

  // sort close order
  SHORT_CLOSE_FETCH_DATA: `${API_BASE_URL}fetch-short-closed-orders`,
  SHORT_CLOSE_ORDERS: `${API_BASE_URL}call-short-closed-orders`,

  //--- Machine Master 
  DECKL_LOADWINDERLIST: `${API_BASE_URL}getwinderlist`,
  DECKL_LOADDUPLEXLIST: `${API_BASE_URL}getduplexlist`,
  DECKL_LOADSIMPLEXLIST: `${API_BASE_URL}getcutterlist`,
  DECKL_LOADWINDERLIST_CODE: `${API_BASE_URL}getWinderMachineListCode`,

  // paper roll production
  PROD_MANAGEMENT_GET_PARENT_ROLL_DETAILS: `${API_BASE_URL}getParentRollDetails`,
  PROD_MANAGEMENT_GET_DIFF_PARENT_ROLL_DETAILS: `${API_BASE_URL}get-differend-parent-roll-ma-details`,
  PROD_MANAGEMENT_GET_LOTNUMBER: `${API_BASE_URL}getLotNumber`,
  PROD_MANAGEMENT_GET_LOTNUMBER_EDIT: `${API_BASE_URL}get-lotnumber-edit`,

  PROD_MANAGEMENT_GET_MACHINE: `${API_BASE_URL}getmachines`,
  PROD_MANAGEMENT_GET_PRODUCED_PARENT_ROLL: `${API_BASE_URL}get-parent-roll-list`,

  PROD_MANAGEMENT_GET_MOLIST: `${API_BASE_URL}getMODetail`,
  PROD_MANAGEMENT_GET_LOTNUMBERDETAILS_PARENT_ROLL: `${API_BASE_URL}getLotDetailsPapaerRoll`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_Number: `${API_BASE_URL}getParentRollNumber`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_INSERTPARENTROLLDET: `${API_BASE_URL}insertParentRollDetails`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_UPDATEPARENTROLLDET: `${API_BASE_URL}updateParentRollDetails`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_DETAILS_USING_ID: `${API_BASE_URL}get-parent-roll-details-parent-roll-id`,
  PROD_MANAGEMENT_UPDATE_PARENT_ROLL_STATUS: `${API_BASE_URL}update-parent-roll-status`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_WISE_CHILD_LIST: `${API_BASE_URL}get-parent-roll-wise-child-rolls`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_WISE_ItemDetails: `${API_BASE_URL}GetParentRollItemDetails`,
  PROD_MANAGEMENT_REMOVE_MA_DETAIL: `${API_BASE_URL}Remove-ma-detail-from-parent-roll`,
  PROD_MANAGEMENT_UPDATE_MA_DETAIL: `${API_BASE_URL}update-ma-detail-from-parent-roll`,


  // winder machine 
  PROD_MANAGEMENT_GET_LOTNUMBERDETAILS: `${API_BASE_URL}getLotDetails`,
  PROD_MANAGEMENT_GET_LOTNUMBERLIST: `${API_BASE_URL}/getLotNumber`,
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS: `${API_BASE_URL}createChildReels`,
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_NEW: `${API_BASE_URL}createChildReels-new`,
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_BASED_ON_REEL_LENGTH: `${API_BASE_URL}create-child-reel-based-on-reel-length`,
  PROD_MANAGEMENT_VALIDATE_CHILD_ROLL_DETAIL: `${API_BASE_URL}validate-child_roll`,
  PROD_MANAGEMENT_ADD_EXTRA_SET: `${API_BASE_URL}add-extra-set-winder-process`,
  PROD_MANAGEMENT_REPORT_GET_WINDER_PRODUCTION_WIP_REELS: `${API_BASE_URL}get-winder_production_wip_reels-list`,
  PROD_MANAGEMENT_REPORT_GET_SHEETER_WIP_PALLETS: `${API_BASE_URL}get-sheeter_conversion_wip_pallet-list`,
  PROD_MANAGEMENT_REPORT_GET_REAMPUNCHING_WIP_REAMS: `${API_BASE_URL}get-reampunching_wip_ream-list`,
  // 
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS: `${API_BASE_URL}getChildReelsAchievement`,
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST: `${API_BASE_URL}getApprovedChildRollList`,
  PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST_USING_SET: `${API_BASE_URL}getApprovedChildRollListUsingSet`,

  PROD_MANAGEMENT_FIND_CHILD_ROLL_WISE_CUSTOMER: `${API_BASE_URL}find-customer-details`,
  PROD_MANAGEMENT_SET_REVERSE_APPROVAL: `${API_BASE_URL}reverse-child-roll-approval-indivitual`,

  PROD_MANAGEMENT_GET_COMBINATION_DETAILS: `${API_BASE_URL}get-combination-details-winder-process`,
  PROD_MANAGEMENT_GET_PROCESSED_SETS: `${API_BASE_URL}get-processed-set-details-winder-process`,

  PROD_MANAGEMENT_GET_PARENT_ROLL_LIST: `${API_BASE_URL}getParentRollList`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_TO_QC_APPROVAL: `${API_BASE_URL}getParentRollListtoQcApproval`,

  PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_BASED_ON_MO_NUMBER: `${API_BASE_URL}get-parent-roll-list-based-on-mo-number`,
  PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_BASED_ON_MA_NUMBER: `${API_BASE_URL}get-parent-roll-list-based-on-ma-number`,

  PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL: `${API_BASE_URL}getSelectedApprovedChildRollDetail`,
  PROD_MANAGEMENT_UPDATE_CHILD_ROLL_DETAIL: `${API_BASE_URL}updateChildReels`,
  PROD_MANAGEMENT_REVERSE_CHILD_ROLL_DETAIL: `${API_BASE_URL}reverse-child-reel-approval`,

  PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_List: `${API_BASE_URL}getApprovedChildRollList`,
  PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_ACHIEVEMENT: `${API_BASE_URL}getChildReelsAchievement`,

  SHEETER_CONVERTION_GET_APROVED_ALL_CHILD_LIST: `${API_BASE_URL}getApprovedAllChildRollList`,
  SHEETER_CONVERTION_GET_REEL_WT_CONFIRMET_CHILDREELS: `${API_BASE_URL}get-reel-weight-confirmed-child-rolls`,
  PRODUCTION_GET_PARAMETERS_SETTINGS: `${API_BASE_URL}get-production-parameters`,

  SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_DETAILS: `${API_BASE_URL}get-order-line-item-list-based-on-mo-number`,
  SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_DETAILS_CONUMBER_FILTER: `${API_BASE_URL}get-order-line-item-list-based-on-co-number`,
  SHEETER_CONVERTION_GET_APROVED_CHILD_ROLL_DETAILS_SHEETER: `${API_BASE_URL}getApprovedChildRollDetailSheeter`,
  SHEETER_CONVERTION_GET_PALLET_DETAILS: `${API_BASE_URL}getPalletDetail`,
  SHEETER_CONVERTION_GET_PALLET_NUMBER: `${API_BASE_URL}getPalletNumber`,
  SHEETER_CONVERTION_UPDATE_PALLET: `${API_BASE_URL}createPallets`,
  SHEETER_CONVERTION_UPDATE_PALLET_MULTI_REELS: `${API_BASE_URL}create-pallets-multiple-reel-execution`,
  SHEETER_CONVERTION_GET_BULK_PALLET_SHEETS: `${API_BASE_URL}get-bulk-pallet-sheets`,
  SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_CHILD_REEL_LIST: `${API_BASE_URL}get-order-line-item-wise-child-roll-number`,
  SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_CHILD_REEL_LIST_USING_JOB_ID: `${API_BASE_URL}get-order-line-item-wise-child-roll-number-using-job-id`,
  SHEETER_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID: `${API_BASE_URL}get-job-details-using-job-id`,
  SHEETER_CONVERTION_PROCESS_LIST: `${API_BASE_URL}get-sheeter-convertion-process-list`,
  SHEETER_GetChildrollSheetsProductionBasedOnCONumberAPI: `${API_BASE_URL}GetChildrollSheetsProductionBasedOnCONumberAPI`,
  SHEETER_DELETE_PALLET_PRODUCTION_JOB_DETAILS: `${API_BASE_URL}delete-pallet-production-job-details`,
  SHEETER_DELETE_SELECTED_PALLET_PRODUCTION_JOB_DETAILS: `${API_BASE_URL}delete-selected-pallets-production-in-job-details`,

  // reel weightment  
  PROD_MANAGEMENT_GET_REEL_WEIGHTMENT_LIST: `${API_BASE_URL}get-reel-weightment-list`,
  PROD_MANAGEMENT_UPDATE_REEL_WEIGHT: `${API_BASE_URL}updateReelWeight`,
  PROD_MANAGEMENT_REVERSE_UPDATE_REEL_WEIGHT: `${API_BASE_URL}reverse-update-reelweight`,

  PROD_MANAGEMENT_GET_DEFAULT_VALUES: `${API_BASE_URL}get-production-default-values`,

  // Production Ream Process
  PROD_MANAGEMENT_GET_PALLET_ORDER_LINE_ITEMS_DETAILS: `${API_BASE_URL}get-order-line-item-list-based-on-pallets`,
  PROD_MANAGEMENT_GET_PALLET_ORDER_LINE_ITEMS_DETAILS_BY_CO_NUMBER: `${API_BASE_URL}get-order-line-item-list-based-on-pallets-filter-by-conumber`,
  PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST: `${API_BASE_URL}get-order-line-item-wise-pallet-number`,
  PROD_MANAGEMENT_GET_PALLET_DETAILS: `${API_BASE_URL}getPalletDetails`,
  PROD_MANAGEMENT_GET_REAM_DETAILS_APPROVED_PALLET: `${API_BASE_URL}getReamDetailsApprovedPallet`,
  PROD_MANAGEMENT_GET_REAM_NUMBER: `${API_BASE_URL}getReamNumber`,
  PROD_MANAGEMENT_GET_REAM_LIST: `${API_BASE_URL}getReamListApprovedPallet`,
  PROD_MANAGEMENT_CREATE_REAM: `${API_BASE_URL}createReams`,
  PROD_MANAGEMENT_CREATE_REAM_USING_MULTIPLE_PALLET: `${API_BASE_URL}create-reams-using-multiple-pallet`,
  PROD_MANAGEMENT_REAM_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST_USING_JOB_ID: `${API_BASE_URL}get-order-line-item-wise-pallet-using-job-id`,
  PROD_MANAGEMENT_REAM_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID: `${API_BASE_URL}get-ream-convertion-job-details-using-job-id`,
  PROD_MANAGEMENT_REAM_PROCESS_LIST: `${API_BASE_URL}get-ream-punching-process-list`,
  PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST_LOOSE_PALLET: `${API_BASE_URL}get-order-line-item-wise-pallet-number-for-loosepallet`,
  PROD_MANAGEMENT_REAM_Get_produced_sheets_based_on_reams_job_number: `${API_BASE_URL}Get_produced_sheets_based_on_reams_job_number`,
  PROD_MANAGEMENT_GET_DISTINCT_ORDERITEM_REAM_PUNCHING: `${API_BASE_URL}get-distinct-order-item-list-ream-punching`,
  PROD_MANAGEMENT_GetPalletProductionBasedOnCONumberAPI: `${API_BASE_URL}GetPalletProductionBasedOnCONumberAPI`,
  PROD_MANAGEMENT_DeleteReamProductionJOB: `${API_BASE_URL}delete-reams-production-job-details`,
  PROD_MANAGEMENT_DeleteSelectedReamsInReamJob: `${API_BASE_URL}delete-selected-reams-in-job`,
  PROD_MANAGEMENT_UPDATE_BUNDLE_PUNCHING_JOB_NUMBER: `${API_BASE_URL}update-bundle-punching-job-details`,
  PROD_MANAGEMENT_UPDATE_REAM_PALLET_PUNCHING_JOB_NUMBER: `${API_BASE_URL}update-ream-pallet-punching-job-details`,

  // Production bundle Process
  PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS: `${API_BASE_URL}get-order-line-item-list-based-on-reams`,
  PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS: `${API_BASE_URL}get-order-line-item-list-based-on-selected-job`,
  PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_REAM_LIST: `${API_BASE_URL}get-order-line-item-wise-ream-number`,
  PROD_MANAGEMENT_GET_APPROVED_PALLET_LIST: `${API_BASE_URL}getApprovedPallets`,
  PROD_MANAGEMENT_GET_APPROVED_PALLET_DETAIL: `${API_BASE_URL}getPalletDetails`,
  PROD_MANAGEMENT_GET_REAM_DETAIL_FOR_BUNDLING: `${API_BASE_URL}getReamsDetailsForBundling`,
  PROD_MANAGEMENT_GET_BUNDLES_NUMBER: `${API_BASE_URL}getBundleNumber`,
  PROD_MANAGEMENT_CREATE_BUNDLES: `${API_BASE_URL}createBundles`,
  PROD_MANAGEMENT_GET_BUNDLES: `${API_BASE_URL}getBundlesForPallet`,
  PROD_MANAGEMENT_GET_BUNDLES_DETAIL: `${API_BASE_URL}getBundlesDetail`,
  PROD_MANAGEMENT_CREATE_BUNDLE_USING_MULTIPLE_REAM: `${API_BASE_URL}create-bundle-using-multiple-reams`,
  PROD_MANAGEMENT_REAM_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_REAM_LIST_USING_JOB_ID: `${API_BASE_URL}get-order-line-item-wise-reams-using-job-id`,
  PROD_MANAGEMENT_BUNDLE_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID: `${API_BASE_URL}get-bundle-convertion-job-details-using-job-id`,
  PROD_MANAGEMENT_BUNDLE_PROCESS_LIST: `${API_BASE_URL}get-bundle-punching-process-list`,
  PROD_MANAGEMENT_GET_DISTINCT_ORDERITEM_BUNDLE_PUNCHING: `${API_BASE_URL}get-distinct-order-item-list-bundle-punching`,
  PROD_MANAGEMENT_GET_REAM_ORDER_LINE_ITEMS_DETAILS_BY_CONUMBER: `${API_BASE_URL}get-order-line-item-list-based-on-reams-by-co-number`,
  PROD_MANAGEMENT_DeleteSelectedBundlesInReamJob: `${API_BASE_URL}delete-selected-bundles-in-job`,
  PROD_MANAGEMENT_DeleteBundleJobDetails: `${API_BASE_URL}delete-bundle-production-job-details`,
  PROD_MANAGEMENT_DeleteReamPalletJobDetails: `${API_BASE_URL}delete-ream-pallet-production-job-details`,


  PROD_MANAGEMENT_REAM_PALLET_PROCESS_LIST: `${API_BASE_URL}get-ream-pallet-punching-process-list`,
  PROD_MANAGEMENT_REAM_PALLET_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID: `${API_BASE_URL}get-ream-pallet-convertion-job-details-using-job-id`,
  PROD_MANAGEMENT_REAM_PALLET_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_REAM_LIST_USING_JOB_ID: `${API_BASE_URL}get-order-line-item-wise-reams-using-job-id-ream-pallet`,
  PROD_MANAGEMENT_GET_SELECTED_ORDER_LINE_ITEMS_DETAILS_REAMPALLET: `${API_BASE_URL}get-order-line-item-list-based-on-selected-job`,
  PROD_MANAGEMENT_CREATE_REAM_PALLET_USING_MULTIPLE_REAM: `${API_BASE_URL}create-ream-pallet-using-multiple-reams`,

  // Production Inventory Log
  PROD_MANAGEMENT_GET_InventoryParentRollLogLoad: `${API_BASE_URL}getAllParentRollDetail_log`,
  PROD_MANAGEMENT_GET_InventoryChildRollLogLoad: `${API_BASE_URL}getAllChildRollDetail_log`,


  // search product
  PROD_MANAGEMENT_GET_SEARCH_PRODUCT_CODE: `${API_BASE_URL}get-search-product-code`,
  PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL: `${API_BASE_URL}get-search-ream-details`,
  PROD_MANAGEMENT_SEARCH_GET_PARENT_ROLL_DETAIL: `${API_BASE_URL}get-search-parent_roll-details`,
  PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL: `${API_BASE_URL}get-search-bundle-details`,
  PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_NEW: `${API_BASE_URL}get-search-bundle-details-new`,
  PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_NEW: `${API_BASE_URL}get-search-ream-pallet-details-new`,
  PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_PRINT: `${API_BASE_URL}get-search-bundle-details-print`,
  PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_PRINT: `${API_BASE_URL}get-search-ream-pallet-details-print`,

  // Warehouse Api call process
  WAREHOUSE_GET_CODE: `${API_BASE_URL}get-warehouse-code`,
  WAREHOUSE_GET_LIST: `${API_BASE_URL}get-warehouse-list`,
  WAREHOUSE_GET_ZONE_CODE: `${API_BASE_URL}get-warehouse-zone-code-auto-generate`,
  WAREHOUSE_INSERT_DETAILS: `${API_BASE_URL}insert-warehouse-details`,
  WAREHOUSE_INSERT_LOCATION: `${API_BASE_URL}insert-warehouse-location`,

  WAREHOUSE_GET_AVAILABLE_SLOT: `${API_BASE_URL}get-warehouse-available-slots`,
  WAREHOUSE_GET_AVAILABLE_SLOT_FOR_BINS: `${API_BASE_URL}get-warehouse-available-slots-for-bins`,

  WAREHOUSE_GET_REEL_LIST: `${API_BASE_URL}get-child_reels_list`,
  WAREHOUSE_GET_REEL_DETAILS: `${API_BASE_URL}get-child_reel_details`,
  WAREHOUSE_INSERT_REEL_TO_WAREHOUSE: `${API_BASE_URL}store-child-reel`,
  WAREHOUSE_GET_CHILD_REEL_LOCATION: `${API_BASE_URL}get-child_reel_location`,

  WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL: `${API_BASE_URL}stack-wise-store-child-reel`,
  WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL_COMPLETE_DETAIL: `${API_BASE_URL}stack-wise-store-child-reel-complete-details`,
  WAREHOUSE_GET_STACK_WISE_ALLOCATED_ALL_REEL_COMPLETE_DETAIL: `${API_BASE_URL}stack-wise-store-all-child-reel-complete-details`,
  WAREHOUSE_GET_BIN_PRODUCT_CODE_LIST: `${API_BASE_URL}bin-storage-product-code-list`,
  WAREHOUSE_GET_SELECTED_PRODUCT_DETAILS: `${API_BASE_URL}bin-storage-selected-product-code-details`,
  WAREHOUSE_INSERT_BIN_STORAGE_PRODUCT_DETAILS: `${API_BASE_URL}insert-bin-storage-product`,
  WAREHOUSE_GET_BIN_PRODUCT_CODE_AND_TYPE: `${API_BASE_URL}get-product-type-and-product-id`,
  WAREHOUSE_GET_AND_STORED_BIN_STORAGE_PRODUCT_DETAILS: `${API_BASE_URL}insert-bin-storage-product`,

  //standars size master

  MASTER_getstandardsizelist: `${API_BASE_URL}master-get-standardsizelist`,
  MASTER_getstandardsizeUsingId: `${API_BASE_URL}master-get-standardsize_using_id`,
  MASTER_delete_standardsize: `${API_BASE_URL}delete_standardsize`,


  //MACHINE MASTER
  MASTER_Add_update_winderdetails: `${API_BASE_URL}add_update_winderdetails`,
  MASTER_Delete_Record: `${API_BASE_URL}delete_winderdetails`,
  MASTER_Add_update_simplexdetails: `${API_BASE_URL}add_update_simplexdetails`,
  MASTER_Delete_Record_simplex: `${API_BASE_URL}delete_simplexdetails`,
  MASTER_Add_update_duplexdetails: `${API_BASE_URL}add_update_duplexdetails`,
  MASTER_Delete_Record_duplex: `${API_BASE_URL}delete_duplexdetails`,

  // Finished goods update process
  FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods: `${API_BASE_URL}get-Stock-RelatedDetails-ForUpdate-FinishedGoods`,
  FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_bundle: `${API_BASE_URL}get-Stock-RelatedDetails-ForUpdate-FinishedGoods-sheets-bundle`,
  FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_Ream_Pallet: `${API_BASE_URL}get-Stock-RelatedDetails-ForUpdate-FinishedGoods-sheets-ream-pallet`,
  FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods_Sheets_Pallet: `${API_BASE_URL}get-Stock-RelatedDetails-ForUpdate-FinishedGoods-sheets-bulk-pallet`,
  WAREHOUSE_TRANSFER_BIN_PRODUCT: `${API_BASE_URL}transfer-bin-storage-product`,


  //-------------------------------------------------SALES------------------------------------------------//

  //Order management
  GET_DEFAULT_REAM_WEIGHT_DETAILS: `${API_BASE_URL}getDefaultReamWeightDetails`,
  GET_MASTER_LIST: `${API_BASE_URL}getMasterList`,
  GET_MASTER_LIST_BY_CODE: `${API_BASE_URL}getMasterListByCode`,
  GetAllHSNLists: `${API_BASE_URL}GetAllHSNLists`,
  getProductDetails: `${API_BASE_URL}getProductDetails`,
  getProductItemList: `${API_BASE_URL}getProductItemList`,
  getProductItems: `${API_BASE_URL}getProductItems`,
  cancelOrderDetails: `${API_BASE_URL}cancelOrderDetails`,
  getPartyAddress: `${API_BASE_URL}getPartyAddress`,
  loadConfirmationOrderDetail: `${API_BASE_URL}loadConfirmationOrderDetail`,
  saveOrderDetails: `${API_BASE_URL}saveOrderDetails`,
  approveOrderDetails: `${API_BASE_URL}approveOrderDetails`,
  getCOList: `${API_BASE_URL}getCOList`,
  getConfirmationOrderDataForDocument: `${API_BASE_URL}getConfirmationOrderDataForDocument`,
  amendOrderDetails: `${API_BASE_URL}amendOrderDetails`,
  generateConfirmationOrder: `${API_BASE_URL}generateConfirmationOrder`,
  MASTER_get_distinct_product_varieties: `${API_BASE_URL}get_distinct_product_varieties`,
  GenerateDataForOrderReport: `${API_BASE_URL}GenerateDataForOrderReport`,
  getDefaultParameterConfig: `${API_BASE_URL}getDefaultParameterConfig`,
  getDefaultParameterConfigById: `${API_BASE_URL}get-parameter-detail-by-id`,

  //Stock management
  getProductItemsInStock: `${API_BASE_URL}getProductItemsInStock`,
  loadPendingConfirmationOrderList: `${API_BASE_URL}loadPendingConfirmationOrderList`,
  getLastReelBundleSequenceNumberForLotNo: `${API_BASE_URL}getLastReelBundleSequenceNumberForLotNo`,
  loadConfirmationOrderListWithUnReservedFG: `${API_BASE_URL}loadConfirmationOrderListWithUnReservedFG`,
  loadPendingConfirmationOrderListAsDestination: `${API_BASE_URL}loadPendingConfirmationOrderListAsDestination`,
  loadTaggedFGListForConfirmationOrderByProductId: `${API_BASE_URL}loadTaggedFGListForConfirmationOrderByProductId`,
  checkDuplicateReelBundleNo: `${API_BASE_URL}checkDuplicateReelBundleNo`,
  updateProductionQtyToInventory: `${API_BASE_URL}updateProductionQtyToInventory`,
  getHSNCodeAll: `${API_BASE_URL}getHSNCodeAll`,
  add_get_ProductGroupDetail: `${API_BASE_URL}add_get_ProductGroupDetail`,
  add_get_ProductSubGroupDetail: `${API_BASE_URL}add_get_ProductSubGroupDetail`,
  add_get_ProductVarietyDetail: `${API_BASE_URL}add_get_ProductVarietyDetail`,
  add_get_location: `${API_BASE_URL}add_get_location`,
  constructProductCode: `${API_BASE_URL}constructProductCode`,
  saveStockDetails: `${API_BASE_URL}saveStockDetails`,
  loadUnreservedFGListForConfirmationOrderSelected: `${API_BASE_URL}loadUnreservedFGListForConfirmationOrderSelected`,
  transferProductionQtyBetweenCO: `${API_BASE_URL}transferProductionQtyBetweenCO`,
  updateStockLocationTransfer: `${API_BASE_URL}updateStockLocationTransfer`,
  salvageStock: `${API_BASE_URL}salvageStock`,
  removeStockFromSystem: `${API_BASE_URL}removeStockFromSystem`,


  //despatch management
  loadDespatchPlanList: `${API_BASE_URL}loadDespatchPlanList`,
  loadConfirmedOrderList: `${API_BASE_URL}loadConfirmedOrderList`,
  loadDespatchOrderDetail: `${API_BASE_URL}loadDespatchOrderDetail`,
  loadConfirmationOrderDetailForDespatchOrder: `${API_BASE_URL}loadConfirmationOrderDetailForDespatchOrder`,
  saveDespatchPlanDetails: `${API_BASE_URL}saveDespatchPlanDetails`,
  approve_amend_DespatchPlanDetails: `${API_BASE_URL}approve_amend_DespatchPlanDetails`,
  cancelDespatchPlanDetails: `${API_BASE_URL}cancelDespatchPlanDetails`,
  showLoadingPlanDespatch: `${API_BASE_URL}showLoadingPlanDespatch`,
  generateDespatchPlan: `${API_BASE_URL}generateDespatchPlan`,
  generateDespatchPlanForViewReport: `${API_BASE_URL}generateDespatchPlanForViewReport`,


  //delivery order management
  LoadShippedOrderList: `${API_BASE_URL}LoadShippedOrderList`,
  LoadDespatchPlanListForDO: `${API_BASE_URL}LoadDespatchPlanListForDO`,
  LoadDespatchOrderDetailForDO: `${API_BASE_URL}LoadDespatchOrderDetailForDO`,
  LoadDespatchPlanDetailForShipmentUpdate: `${API_BASE_URL}LoadDespatchPlanDetailForShipmentUpdate`,
  saveDeliveyOrderDetails: `${API_BASE_URL}saveDeliveyOrderDetails`,
  LoadShippedOrderDetail: `${API_BASE_URL}LoadShippedOrderDetail`,
  approve_amend_DeliveyOrderDetails: `${API_BASE_URL}approve_amend_DeliveyOrderDetails`,
  cancelDeliveryOrderDetails: `${API_BASE_URL}cancelDeliveryOrderDetails`,
  generateDeliveryPackingList: `${API_BASE_URL}generateDeliveryPackingList`,
  generateDeliveryPickList: `${API_BASE_URL}generateDeliveryPickList`,
  generateDeliveryPickListForViewReport: `${API_BASE_URL}generateDeliveryPickListForViewReport`,

  //invoice management
  LoadInoviceOrderList: `${API_BASE_URL}LoadInoviceOrderList`,
  LoadInvoiceOrder_Combined_Invoice_Print: `${API_BASE_URL}LoadInvoiceOrder_Combined_Invoice_Print`,
  saveInvoiceOrderDetails: `${API_BASE_URL}saveInvoiceOrderDetails`,
  approve_amend_InvoiceOrderDetails: `${API_BASE_URL}approve_amend_InvoiceOrderDetails`,
  CancelInvoiceOrderDetails: `${API_BASE_URL}CancelInvoiceOrderDetails`,
  GenerateInvoiceOrder: `${API_BASE_URL}GenerateInvoiceOrder`,
  LoadInvoiceOrder_Combined_Invoice: `${API_BASE_URL}LoadInvoiceOrder_Combined_Invoice`,
  LoadInvoiceOrder_Combined_Invoice_for_CreateInvoice: `${API_BASE_URL}LoadInvoiceOrder_Combined_Invoice_for_CreateInvoice`,
  InvoiceReportGenerate: `${API_BASE_URL}generate`,
  DownloadPackingListExcelReport: `${API_BASE_URL}DownloadPackingListExcelReport`,
  REPORT_INVOICE_PACKINGLIST: `${API_BASE_URL}Report_Invoice_PackingList`,
  REPORT_INVOICE_ALL_COPIES: `${API_BASE_URL}Get_Invoice_Report_All_Copies`,
  FIND_ALL_MASTER_DATA: `${API_BASE_URL}get-all-master-data`,

  //standard sizes

  STANDARD_add_update_standardsize: `${API_BASE_URL}add_update_standardsize`,

  //un used party master
  // LoadPartyList: `${API_BASE_URL}LoadPartyList`,
  // savePartyDetails: `${API_BASE_URL}savePartyDetails`,
  // GetPartyDetail: `${API_BASE_URL}GetPartyDetail`,
  // Action_ValidatePartyExcelData: `${API_BASE_URL}Action_ValidatePartyExcelData`,
  // saveExcelPartyDetails: `${API_BASE_URL}saveExcelPartyDetails`,

  //SalesReport
  GetIndentSummaryList: `${API_BASE_URL}GetIndentSummaryList`,
  GetCOSummaryList: `${API_BASE_URL}GetCOSummaryList`,
  GetCOStockSummaryList: `${API_BASE_URL}GetCOStockSummaryList`,
  GetInvoicedSummaryReport: `${API_BASE_URL}GetInvoicedSummaryReport`,

  //Product Master
  GetProductList: `${API_BASE_URL}GetProductList`,
  GetProductData: `${API_BASE_URL}GetProductData`,
  GetProductDataAll: `${API_BASE_URL}GetProductDataAll`,
  Promaster_getProductDetails: `${API_BASE_URL}Promaster_getProductDetails`,
  AddOrUpdateProductGroup: `${API_BASE_URL}AddOrUpdateProductGroup`,
  AddOrUpdateProductSubGroup: `${API_BASE_URL}AddOrUpdateProductSubGroup`,
  AddOrUpdateProductVariety: `${API_BASE_URL}AddOrUpdateProductVariety`,
  AddOrUpdateProductDepartment: `${API_BASE_URL}AddOrUpdateProductDepartment`,

  // -- designation
  MASTER_ADD_OR_UPDATE_DESIGNATION: `${API_BASE_URL}add-update-designation`,

  //CO Order to DM(deckle matching)
  GetConfirmedOrderListForDeckleMatching: `${API_BASE_URL}GetConfirmedOrderListForDeckleMatching`,
  UploadSelectedItemsToDM: `${API_BASE_URL}UploadSelectedItemsToDM`,
  ProcessSalesOrderData: `${API_BASE_URL}so`,
  UpdateDMStatusInConfirmationItem: `${API_BASE_URL}UpdateDMStatusInConfirmationItem`,


  //party master
  LoadPartyList: `${API_BASE_URL}LoadPartyList`,
  AddPartyDetails: `${API_BASE_URL}add-party`,
  GETPartyList: `${API_BASE_URL}party-list`,
  GETPartyDetails: `${API_BASE_URL}get-party-details`,
  PURCHASE_GET_VENDOR_LIST_BY_TYPE: `${API_BASE_URL}get-vendor-list-by-type`,
 PURCHASE_GET_VENDOR_LIST_BY_TYPE_DESC: `${API_BASE_URL}get-vendor-list-by-type-description`,


  // party Master Get data
  PURCHASE_MANAGEMENT_GET_PARTY_TYPE: `${API_BASE_URL}party-type`,
  PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS: `${API_BASE_URL}payment-terms`,
  PURCHASE_MANAGEMENT_GET_CURRENCY_LIST: `${API_BASE_URL}currency-list`,
  PURCHASE_MANAGEMENT_GET_CREDIT_TERMS: `${API_BASE_URL}credit_terms`,
  PURCHASE_MANAGEMENT_GET_CREDIT_LIMIT_RULES: `${API_BASE_URL}credit_limit_rules`,
  PURCHASE_MANAGEMENT_GET_TDS: `${API_BASE_URL}tds`,
  PURCHASE_MANAGEMENT_CRUD_TDS: `${API_BASE_URL}crud-tds`,
  PURCHASE_MANAGEMENT_CRUD_PAYMENT_TERMS: `${API_BASE_URL}crud-payment-terms`,
  PURCHASE_MANAGEMENT_CRUD_CREDIT_TERMS: `${API_BASE_URL}crud-credit-terms`,
  PURCHASE_MANAGEMENT_CRUD_PARTY_TYPE: `${API_BASE_URL}crud-party-type`,

  // Location Master Get data

  Location_GET_COUNTRY: `${API_BASE_URL}country-list`,
  Location_GET_STATE: `${API_BASE_URL}state-list`,
  Location_GET_CITY: `${API_BASE_URL}city-list`,
  Location_GET_ALL_CITY: `${API_BASE_URL}all-city-list`,
  Location_GET_LOCATION_ID: `${API_BASE_URL}location-list`,


  //department
  DEPARTMENT_GET: `${API_BASE_URL}department-list`,

  //designation 
  DESIGNATION_GET: `${API_BASE_URL}designation-list`,

  // blood group list
  BLOOD_GROUP_GET: `${API_BASE_URL}blood-group-list`,

  // job level list
  JOB_LEVEL_LIST: `${API_BASE_URL}job-level-list`,

  // employee status
  MASTER_GET_EMPLOYEE_STATUS: `${API_BASE_URL}employee-list`,

  // Purchase Order Number
  PURCHASE_ORDER_GET_PO_NUMBER: `${API_BASE_URL}purchase-order-number`,

  PURCHASE_ORDER_GET_PO_ACCOUNTS: `${API_BASE_URL}purchase-accounts`,
  PURCHASE_ORDER_ADD_PURCHASE_ORDER: `${API_BASE_URL}create-purchase-order`,
  PURCHASE_ORDER_GET_PURCHASE_ORDER: `${API_BASE_URL}get-purchase-order`,
  PURCHASE_ORDER_GET_PURCHASE_ORDER_LIST: `${API_BASE_URL}get-purchase-orders-list`,

  PURCHASE_ORDER_GET_PR_NUMBER: `${API_BASE_URL}purchase-receive-number`,
  PURCHASE_ORDER_GET_PO_NUMBER_RECEIVE: `${API_BASE_URL}po-number-receive`,

  PURCHSE_RECEIVE_DETAILS: `${API_BASE_URL}purchase-receive-details`,
  PURCHASE_CREATE_RECEIVE: `${API_BASE_URL}create-purchase-receive`,
  PURCHASE_RECEIVE_LIST: `${API_BASE_URL}get-purchase-receive-list`,
  PURCHASE_RECEIVE_LIST_BY_ID: `${API_BASE_URL}get-purchase-receive-details-by-receives-id`,

  SEND_EMAIL: `https://api.sendgrid.com/v3/mail/send`,

  //Purchase Return
  PURCHASE_ORDER_GET_RETURN_NUMBER: `${API_BASE_URL}purchase-return-number`,
  PURCHASE_ORDER_GET_PT_NUMBER_RECEIVE: `${API_BASE_URL}pr-number-return-process`,


  PURCHSE_RETURN_DETAILS: `${API_BASE_URL}purchase-return-details`,
  PURCHASE_CREATE_RETURN: `${API_BASE_URL}create-purchase-return`,
  PURCHASE_RETURN_LIST: `${API_BASE_URL}get-purchase-return-list`,
  PURCHASE_RETURN_LIST_BY_ID: `${API_BASE_URL}get-purchase-return-details-by-return-id`,

  // Purchase Inspection  
  PURCHASE_ORDER_GET_INSPECTION_NUMBER: `${API_BASE_URL}purchase-inspection-number`,
  PURCHSE_INSPECTION_DETAILS: `${API_BASE_URL}purchase-inspection-details`,
  PURCHASE_CREATE_INSPECTION: `${API_BASE_URL}create-purchase-inspection`,
  PURCHASE_INSPECTION_LIST: `${API_BASE_URL}get-purchase-inspection-list`,
  PURCHASE_INSPECTION_LIST_BY_ID: `${API_BASE_URL}get-purchase-inspection-details-by-inspection-id`,
  PURCHASE_APPROVAL_INSPECTION: `${API_BASE_URL}approve-purchase-inspection`,

  //Purchase Return Inspection
  PURCHASE_INSPECTION_RETURN_LIST: `${API_BASE_URL}get-purchase-Inspection-return-list`,
  PURCHSE_INSPECTION_RETURN_DETAILS: `${API_BASE_URL}purchase-inspection-return-details`,
  PURCHASE_CREATE_Inspection_RETURN: `${API_BASE_URL}create-purchase-inspection-return`,

  //Maerial Stock Master
  MATERIAL_STOCK_SaveMaterialStockDetails: `${API_BASE_URL}SaveMaterialStockDetails`,
  MATERIAL_STOCK_GetMaterialStockDetails: `${API_BASE_URL}GetMaterialStockDetails`,


  // Employee number
  HR_GET_EMPLOYEE_NUMBER: `${API_BASE_URL}employee-number`,

  PRODUCT_ITEM_LIST: `${API_BASE_URL}product-list`,

  DISCOUNT_LIST: `${API_BASE_URL}discount-list`,
  TCS_LIST: `${API_BASE_URL}tcs-list`,
  TDS_LIST: `${API_BASE_URL}tds-list`,



  //////////////////////////////////////////////////////////////////////////////////////////

  //PRODUCTION FG STOCK REPORT
  PRODUCTION_GET_FG_STOCK_REPORT: `${API_BASE_URL}get-production-fg-stock-report-details`,

  //QC Certificate 
  PRODUCTION_SAVE_QC_DATA: `${API_BASE_URL}saveJumboWiseQualtiyCertificateDetails`,
  PRODUCTION_GET_QC_CERTIFICATE_DETAILS: `${API_BASE_URL}getJumboWiseQualtiyCertificateDetailsByJumboRollCode`,
  PRODUCTION_GetALLQualityCertificateDetails: `${API_BASE_URL}getALLQualityCertificateDetails`,
  PRODUCTION_GET_QC_CERTIFICATE_DETAILS_WITHOUT_ORDERDETAILS: `${API_BASE_URL}getJumboWiseQualtiyCertificateDetailsWithOutOrderDetailsByJumboRollCode`,
  PRODUCTION_PARENTROLL_UPDATE_QC_APPROVAL_STATUS: `${API_BASE_URL}update-parent-roll-qc-approval-status`,
  PRODUCTION_GetParentRollQCStatus: `${API_BASE_URL}GetParentRollQCStatus`,
  PRODUCTION_GetALLQualityCertificateDetailsByOrderNo: `${API_BASE_URL}getALLQualityCertificateDetailsByOrderNo`,


  PRODUCTION_GET_PARENT_ROLL_LIST: `${API_BASE_URL}get-parent-rolls-by-inputs`,
  CUSTOMERORDER_MAPPING_SaveCustomerOrderMappingDetails: `${API_BASE_URL}SaveCustomerOrderMappingDetails`,
  CUSTOMERORDER_MAPPING_GetALLCustomerOrderMappingDetails: `${API_BASE_URL}GetALLCustomerOrderMappingDetails`,


  //PRODUCTION REPORTS

  REPORT_GetreportProductionGetParentRollDetails: `${API_BASE_URL}GetreportProductionGetParentRollDetails`,
  REPORT_GetreportProductionGetWinderChildRollDetails: `${API_BASE_URL}GetreportProductionGetWinderChildRollDetails`,
  REPORT_GetreportProductionGetFGChildRollDetails: `${API_BASE_URL}GetreportProductionGetFGChildRollDetails`,
  REPORT_GetreportProductionSheetCuttingDetails: `${API_BASE_URL}GetreportProductionSheetCuttingDetails`,
  REPORT_GetreportProductionReamBundleDetails: `${API_BASE_URL}GetreportProductionReamBundleDetails`,
  REPORT_GetProductionOrderWiseReelPendingConversionDet: `${API_BASE_URL}GetProductionOrderWiseReelPendingConversionDet`,
  REPORT_GetProductionOrderWiseReamAndBundlePendingConversionDet: `${API_BASE_URL}GetProductionOrderWiseReamAndBundlePendingConversionDet`,
  REPORT_GetProductionDistinctOrderNoForConversionReport: `${API_BASE_URL}GetProductionDistinctOrderNoForConversionReport`,
  REPORT_GetreportChildReelWiseReamProductionDetails: `${API_BASE_URL}GetreportProductionChildReelWiseReamProductionDetails`,
  REPORT_GetreportProductionGetReWinderDetails: `${API_BASE_URL}GetreportProductionGetReWinderDetails`,



  //user management:

  USER_insertUpdateUserDetails: `${API_BASE_URL}insertUpdateUserDetails`,
  USER_getUserDataByCompanyID: `${API_BASE_URL}getUserDataByCompanyID`,
  USER_getUserRoles: `${API_BASE_URL}getUserRoles`,
  USER_getUserAccessModules: `${API_BASE_URL}getUserAccessModules`,
  USER_getUserAccessModulesPermissions: `${API_BASE_URL}getUserAccessModulesPermissions`,
  USER_insertRoleModulePermissions: `${API_BASE_URL}insertRoleModulePermissions`,
  USER_getParentModules: `${API_BASE_URL}getParentModules`,
  USER_getUserModulePermissionsForRestiction: `${API_BASE_URL}getUserModulePermissionsForRestiction`,
  USER_getRoleModulePermissionsByRoleID: `${API_BASE_URL}getRoleModulePermissionsByRoleID`,
  USER_deleteUserDetails: `${API_BASE_URL}deleteUserDetails`,
  USER_insertUpdateUserRoles: `${API_BASE_URL}insertUpdateUserRoles`,
  USER_deleteUserRoles: `${API_BASE_URL}deleteUserRoles`,
  USER_getUserDataExistsOrNot: `${API_BASE_URL}getUserDataExistsOrNot`,
  USER_logout: `${API_BASE_URL}logout`,

  //Company management

  COMPANY_GetCompanyList: `${API_BASE_URL}getCompanyList`,
  COMPANY_Getmilltype: `${API_BASE_URL}getmilltype`,
  COMPANY_GetSubscriptionModelListFunc: `${API_BASE_URL}getSubscriptionModelListFunc`,
  COMPANY_addUpdateCompanyDetails: `${API_BASE_URL}addUpdateCompanyDetails`,
  COMPANY_deleteCompanyDetails: `${API_BASE_URL}deleteCompanyDetails`,

  // Human Resource
  HR_SALARY_COMPONENTS_LIST: `${API_BASE_URL}salary-components-list`,



  //Employee attendance
  EMPLOYEE_ATTENDANCE_ADD_UPDATE: `${API_BASE_URL}SaveEmployeeAttendance`,
  EMPLOYEE_GetEmployeeLists: `${API_BASE_URL}GetEmployeeLists`,
  EMPLOYEE_GET_EMPLOYEE_ATTENDANCE_LIST: `${API_BASE_URL}GetEmployeeAttendanceList`,
  EMPLOYEE_LEAVE_TYPE: `${API_BASE_URL}GetLeaveType`,
  EMPLOYEE_InsertEmployeeLeaveRequest: `${API_BASE_URL}InsertEmployeeLeaveRequest`,
  EMPLOYEE_GetEmployeeLeaveRequestList: `${API_BASE_URL}GetEmployeeLeaveRequestList`,
  EMPLOYEE_UpdateEmployeeLeaveRequestStatus: `${API_BASE_URL}UpdateEmployeeLeaveRequestStatus`,
  EMPLOYEE_InsertEmployeeOverTimeDetails: `${API_BASE_URL}InsertEmployeeOverTimeDetails`,
  EMPLOYEE_GetEmployeeOvertimeRequestList: `${API_BASE_URL}GetEmployeeOvertimeRequestList`,
  EMPLOYEE_UpdateEmployeeOvertimeRequestStatus: `${API_BASE_URL}UpdateEmployeeOvertimeRequestStatus`,
  EMPLOYEE_InsertAndUpdateEmployeeLeaveBalance: `${API_BASE_URL}InsertAndUpdateEmployeeLeaveBalance`,
  EMPLOYEE_GetEmployeeLeaveBalanceList: `${API_BASE_URL}GetEmployeeLeaveBalanceList`,
  EMPLOYEE_GetEmployeeListByDepartment: `${API_BASE_URL} GetEmployeeListsByDepartment`,
  EMPLOYEE_GetReportingManagersList: `${API_BASE_URL}GetReportingManagersList`,

  EMPLOYEE_ATTENDANCE_GET_MONTHLY_DETAIL_BY_EMPLOYEE_ID: `${API_BASE_URL}get-employee-month-wise-attendance-detail`,


  // Employee
  HR_CRUD_EMPLOYEE_DETAILS: `${API_BASE_URL}employee-details-crud-process`,
  HR_GET_EMPLOYEE_DETAILS: `${API_BASE_URL}all-employee-list`,
  HR_EDIT_EMPLOYEE_DETAILS: `${API_BASE_URL}edit-employee-details`,
  HR_CRUD_EMPLOYEE_EXIT: `${API_BASE_URL}employee-exit`,
  HR_GET_EMPLOYEE_EXIT_DETAIL: `${API_BASE_URL}employee-exit-detail`,
  // GETPartyDetails: `${API_BASE_URL}get-party-details`,

  //Project
  HR_GET_PROJECT_NUMBER: `${API_BASE_URL}project-number`,
  HR_CRUD_PROJECT_DETAILS: `${API_BASE_URL}project-details-crud-process`,
  HR_GET_PROJECT_List: `${API_BASE_URL}project-list`,
  HR_EDIT_PROJECT_DETAIL: `${API_BASE_URL}edit-project-detail`,
  HR_GET_PROJECT_LEAD: `${API_BASE_URL}get-project-lead`,

  // shift master details
  HR_SHIFT_MASTER_LIST: `${API_BASE_URL}get-shift-list`,
  HR_SHIFT_DETAIL: `${API_BASE_URL}get-shift-detail`,
  HR_SHIFT_MASTER_ADD: `${API_BASE_URL}insert-shift-detail`,
  HR_SHIFT_MASTER_UPDATE: `${API_BASE_URL}update-shift-detail`,

  // shift roaster details
  HR_SHIFT_ROASTER_MASTER_LIST: `${API_BASE_URL}get-shift-roaster-list`,
  HR_SHIFT_ROASTER_DETAIL: `${API_BASE_URL}get-shift-roaster-detail`,
  HR_SHIFT_ROASTER_MASTER_ADD: `${API_BASE_URL}insert-shift-roaster-detail`,
  HR_SHIFT_ROASTER_MASTER_UPDATE: `${API_BASE_URL}update-shift-roaster-detail`,

  // shift employee assignment details
  HR_SHIFT_EMPLOYEE_ASSIGNMENT_LIST: `${API_BASE_URL}GetShiftEmployeeAssignmentListAsync`,
  HR_SHIFT_EMPLOYEE_ASSIGNMENT_ROASTER_MASTER_LIST: `${API_BASE_URL}get-shift-employee-roaster-list`,
  HR_SHIFT_EMPLOYEE_LIST_BY_DEPARTMENT: `${API_BASE_URL}get-shift-employee-list-by-departmentid`,
  HR_SHIFT_EMPLOYEE_ASSIGNMENT_ROASTER_ADD: `${API_BASE_URL}insert-shift-emloyee_assignment-detail`,
  HR_SHIFT_EMPLOYEE_ASSIGNMENT_STATUS: `${API_BASE_URL}get-shift-assignment-status`,
  HR_SHIFT_ASSIGNED_EMPLOYEES_LIST: `${API_BASE_URL}GetShiftAssigedEmployeesListAsync`,

  //skill list
  HR_EMPLOYEE_SKILLS_LIST: `${API_BASE_URL}GetEmployeeSkillListByEmployee`,
  HR_EMPLOYEE_SKILL_LEVEL_MASTER_LIST: `${API_BASE_URL}GetEmployeeSkillLevelMaster`,
  // storage location list

  PRODUCTION_STORAGE_LOCATION_LIST: `${API_BASE_URL}get-storage-location-list`,
  PRODUCTION_ADD_STORAGE_LOCATION: `${API_BASE_URL}add-storage-location`,
  PRODUCTION_FILTER_DATA: `${API_BASE_URL}filter-data-by-so-number`,
  PRODUCTION_SAVE_STORAGE_LOCATION: `${API_BASE_URL}save-storage-location`,
  PRODUCTION_VIEW_STORAGE_LOCATION: `${API_BASE_URL}view-report-by-so-number`,
  PRODUCTION_STORAGE_GET_SO_NUMBER_LIST: `${API_BASE_URL}get-so_number-list-for-storage-location`,
  PRODUCTION_GET_SO_NUMBER_LIST_REEL_TRANSFER: `${API_BASE_URL}get-so_number-list-for-reel-transfer`,
  PRODUCTION_GET_SO_NUMBER_WISE_LINE_ITEMS_REEL_TRANSFER: `${API_BASE_URL}get-so_number-wise-line-item-detail`,
  PRODUCTION_GET_SO_NUMBER_WISE_CHILD_ROLL_LIST: `${API_BASE_URL}filter-data-by-so-number-for-reel-transfer`,
  PRODUCTION_GET_UPDATE_TRANSFER_REEL_DETAIL: `${API_BASE_URL}reel-transfer-crud-process`,
  PRODUCTION_GET_TRANSFER_REEL_LIST: `${API_BASE_URL}reel-transfer-list`,
  PRODUCTION_FILTER_DATA_SO_PACKAGE_TYPE: `${API_BASE_URL}filter-data-by-so-number-and-package-type`,

  PRODUCTION_packagetype_list: `${API_BASE_URL}get-so_number-wise-package-type-list`,

  PRODUCTION_FILTER_DATA_SO_PACKAGE_TYPE_LOCATION: `${API_BASE_URL}filter-data-by-so-number-and-package-type-and-location`,
  PRODUCTION_SAVE_STORAGE_LOCATION_NEW_WAREHOUSE: `${API_BASE_URL}save-storage-location-new-warehouse`,
  PRODUCTION_STORAGE_GET_SO_NUMBER_LIST_WAREHOUSE: `${API_BASE_URL}get-so_number-list-for-storage-location-warehouse`,
  



  // store 
  STORE_GET_STORE_NUMBER: `${API_BASE_URL}get-store-code`,
  STORE_GRUD_PROCESS: `${API_BASE_URL}async-crud_store`,
  STORE_GET_DETAIL: `${API_BASE_URL}async-get_store_detail_by_id`,
  STORE_GET_STORE_LIST: `${API_BASE_URL}async-get_store_list`,

  // Material 
  MATERIAL_GET_CODE: `${API_BASE_URL}get-material-code`,
  MATERIAL_GRUD_PROCESS: `${API_BASE_URL}async-crud-material`,
  MATERIAL_GET_DETAIL: `${API_BASE_URL}async-get_material-detail-by-id`,
  MATERIAL_GET_LIST: `${API_BASE_URL}async-get-material-list`,
  MATERIAL_GET_CATEGORY: `${API_BASE_URL}async-get-material-category-list`,

  //Material sub category
  MATERIAL_SUB_CATEGORY_GET_LIST: `${API_BASE_URL}async-get-material-sub-category-list`,
  MATERIAL_SUB_CATEGORY_CRUD: `${API_BASE_URL}add_delete_subCategory`,

  MATERIAL_GET_STOCK_REORDERLEVEL: `${API_BASE_URL}async-get-material-stock-reorderlevel`,

  VENDOR_GET_LIST: `${API_BASE_URL}vendor-list`,

  //category
  CATEGORY_CRUD: `${API_BASE_URL}addCategory`,
  CATEGORY_DELETE: `${API_BASE_URL}deleteCategory`,

  //material shade

  MATERIAL_SHADE_CRUD_PROCESS: `${API_BASE_URL}addShades`,
  MATERIAL_SHADE_GET_LIST: `${API_BASE_URL}get-material-shades-list`,
  MATERIAL_SHADE_DELETE_PROCESS: `${API_BASE_URL}deleteShades`,

  //MATERIAL ATTRIBUTES MASTER

  MATERIAL_ATTRIBUTE_CRUD_PROCESS: `${API_BASE_URL}async-crud-material-attribute`,
  MATERIAL_ATTRIBUTE_GET_LIST: `${API_BASE_URL}get-material-category-attributes-list`,

  // uom list
  UOM_GET_LIST: `${API_BASE_URL}async-get-unit_of_measurement`,

  // request indent
  REQUEST_INDENT_GET_LIST: `${API_BASE_URL}async-get-request_indent-list`,
  REQUEST_INDENT_GET_CODE: `${API_BASE_URL}get-request-indent-code`,
  REQUEST_INDENT_CRUD_PROCESS: `${API_BASE_URL}async-crud-request-indent`,
  REQUEST_INDENT_GET_DETAIL_BY_ID: `${API_BASE_URL}async-get_request_indent-detail-by-request-id`,

  // request 
  APPROVED_INDENT_CRUD_PROCESS: `${API_BASE_URL}async-approve-request-indent`,
  LIST_OUT_REQUEST_NO_BY_DEPARTMENT_ID: `${API_BASE_URL}list-out-request-indent-number-by-departmentID`,

  // isued indent
  ISSUED_INDENT_GET_CODE: `${API_BASE_URL}get-issue-indent-code`,
  ISSUED_GET_REQUEST_INDENT_DETAIL: `${API_BASE_URL}get-issue-detail-by-request-indent-number-id`,
  ISSUED_INDENT_CRUD_PROCESS: `${API_BASE_URL}async-crud-issue-indent`,
  ISSUED_INDENT_GET_DETAIL_BY_ID: `${API_BASE_URL}async-get_issue_indent-detail-by-issue-id`,


  RETURN_INDENT_GET_LIST: `${API_BASE_URL}async-get-request_indent-list`,
  RETURN_INDENT_CRUD_PROCESS: `${API_BASE_URL}async-crud-return-indent`,
  RETURN_INDENT_GET_ISSUED_NUMBER_LIST: `${API_BASE_URL}list-out-issued-indent-number-in-return`,
  RETURN_INDENT_GET_CODE: `${API_BASE_URL}get-Return-issue-indent-code`,
  RETURN_INDENT_GET_ISSUE_DETAIL: `${API_BASE_URL}get-issue-item-detail-by-issue-indent-number-id`,
  RETURN_INDENT_GET_DETAIL_BY_ID: `${API_BASE_URL}async-get_return_indent-detail-by-return-id`,

  // store ledger
  STORE_LEDGER_GET_LIST: `${API_BASE_URL}async-get-store-ledger-list`,
  STORE_LEDGER_GET_LIST_STOCK_AGE: `${API_BASE_URL}async-get-store-ledger-list-stock-Age`,
  STORE_LEDGER_TRANSACTION_GET_LIST: `${API_BASE_URL}async-get-store-ledger-transaction-list`,


  //bom
  BILL_MATERIAL_GET_CODE: `${API_BASE_URL}get-bom-code`,
  BILL_MATERIAL_GRUD_PROCESS: `${API_BASE_URL}async-crud-bill-of-material`,
  BILL_MATERIAL_GET_DETAIL: `${API_BASE_URL}get-bom-detail-by-bomid`,
  BILL_MATERIAL_GET_LIST: `${API_BASE_URL}get-bom-detail-list`,
  BILL_MATERIAL_GET_CATEGORY: `${API_BASE_URL}async-get-material-category-list`,
  BILL_MATERIAL_GET_ID: `${API_BASE_URL}get-bom-id-by-productvariety-id`,
  BILL_MATERIAL_GET_MO_LIST: `${API_BASE_URL}get-mo-product-variety-wise-production`,
  


  BILL_MATERIAL_CREATE_MO_WISE: `${API_BASE_URL}async-crud-bill-of-material-mo-product`,//get-product-wise-bom-detail-list  
  BILL_MATERIAL_GET_LIST_SUMMARY: `${API_BASE_URL}get-product-wise-bom-detail-list`,
  BILL_MATERIAL_GET_DETAIL_SUMMARY: `${API_BASE_URL}get-product-wise-bom-detail-by-bomid`,
  PRODUCT_GET_LIST: `${API_BASE_URL}get-product-variety-list`,


  //purchase indent

  PURCHASE_INDENT_GET_CODE: `${API_BASE_URL}get-purchase-indent-code`,
  PURCHASE_GET_REQUEST_INDENT_DETAIL: `${API_BASE_URL}get-purchase-detail-by-request-indent-number-id`,
  PURCHASE_INDENT_CRUD_PROCESS: `${API_BASE_URL}async-crud-purchase-indent`,
  PURCHASED_INDENT_GET_DETAIL_BY_ID: `${API_BASE_URL}async-get_purchase_indent-detail-by-purchase-id`,
  PURCHASED_RECEIVED_GET_TABLE_DETAIL_BY_ID: `${API_BASE_URL}get-purchase-receive-report-by-id`,

  // material plan year 
  BILL_MATERIAL_PLAN_CRUD: `${API_BASE_URL}async-crud-product-budget-plan`,
  BILL_MATERIAL_PLAN_PRODUCT_GET_LIST: `${API_BASE_URL}get-budgetplan-product-list`,
  BILL_MATERIAL_PLAN_GET_PRODUCT_WISE_PLAN: `${API_BASE_URL}get-budgetplandetails-by-product`,

  // costing process
  COSTING_GET_COSTING_CATEGORIES: `${API_BASE_URL}async-get-costing-categories`,
  COSTING_GET_EXPENSES_CATEGORIES: `${API_BASE_URL}async-get-costing-categories-expenses`,

  //vendor enquiry
  VENDOR_ENQUIRY_GET_LIST: `${API_BASE_URL}get-vendor-enquiry-list`,
  VENDOR_ENQUIRY_CRUD_PROCESS: `${API_BASE_URL}async-crud-vendor-enquiry`,
  VENDOR_ENQUIRY_GET_DETAIL_BY_ID: `${API_BASE_URL}async-get_vendor-enquiry-detail-by-enquiry-id`,
  VENDOR_ENQUIRY_GET_VENDOR_ITEM_DETAIL: `${API_BASE_URL}get-vendor-enquiry-items-by-vendor-enquiry-id`,
  VENDOR_ENQUIRY_GET_DETAIL_BY_DEPARTMENT_ID: `${API_BASE_URL}async-get_vendor-enquiry-detail-by-department-id`,
  VENDOR_GET_VENDOR_DETAIL_BY_MATERIAL: `${API_BASE_URL}async-get-vendor-list-by-material-details`,
  VENDOR_GET_REPORT_VENDOR_ENQUIRY_DETAIL_ENQUIRY_ID: `${API_BASE_URL}async-get-report-enquiry-details-by-vendor-enquiry-id`,


  //vendor REPONSE
  VENDOR_RESPONSE_GET_VENDOR_LIST: `${API_BASE_URL}get-vendor-list-by-enquiryid`,
  VENDOR_RESPONSE_GET_MATERIALS_LIST: `${API_BASE_URL}get-material-list-by-vendorid`,
  VENDOR_RESPONSE_GET_VENDOR_ITEM_DETAIL: `${API_BASE_URL}get-vendor-quotation-items-by-vendor-enquiry-id`,
  VENDOR_QUOTATION_GET_LIST: `${API_BASE_URL}get-vendor-quotation-list`,

  VENDOR_RESPONSE_CRUD_PROCESS: `${API_BASE_URL}async-crud-vendor-enquiry-quotation`,

  VENDOR_QUOTE_COMPARISON_LIST: `${API_BASE_URL}get-vendor-quote-comparison-list`,

  //category
  BANK_ACCOUNT_CRUD: `${API_BASE_URL}add-bank-account`,
  BANK_ACCOUNT_DELETE: `${API_BASE_URL}delete-bank-account`,

  //salary structure components
  SALARY_STRUCTURE_COMPONENTS_CRUD: `${API_BASE_URL}async-crud-salary-structure-components`,
  SALARY_STRUCTURE_LIST: `${API_BASE_URL}get-salary-structure-list`,
  SALARY_STRUCTURE_DETAIL_BY_ID: `${API_BASE_URL}get-salary-structure-detail-by-id`,

  // salary compensation
  SALARY_STRUCTURE_COMPENSATION_CRUD: `${API_BASE_URL}async-crud-employee-compensation`,
  SALARY_STRUCTURE_GET_COMPENSATIONS_BY_EMPLOYEE_ID: `${API_BASE_URL}get-employee-compensation-detail-by-employee-id`,
  SALARY_STRUCTURE_GET_SALARY_SLIP_BY_EMPLOYEE_ID: `${API_BASE_URL}get-employee-salary-slip-details-by-employee-id`,

  // ament request call process
  REQUEST_APPROVAL_FOR_AMENT_PROCESS: `${API_BASE_URL}crud-amend-request-and-approval`,
  VIEW_ALL_REQUEST_APPROVAL_FOR_AMENT_PROCESS_BY_EMPLOYEE_ID: `${API_BASE_URL}get-amend-request-and-approval-list`,

  // bank account type
  BANK_ACCOUNT_TYPE_LIST: `${API_BASE_URL}get-bank-account-type-list`,

  //06-05-2025 Parent roll production report
  PRODUCTION_PARENT_ROLL_MA_WISE_BALANCE_QTY: `${API_BASE_URL}get-parent-roll-ma-wise-balance-qty`,

  REAM_PALLET_UPDATE_GROSS_WEIGHT: `${API_BASE_URL}update-ream-pallet-gross-weight`,
  COMPANY_GET_DETAILS_BY_ID: `${API_BASE_URL}get-company-details`,

  TRACKING_GET_DETAIL_BY_SO_AND_CR: `${API_BASE_URL}get-tracking-det-by-so-and-cr`,
  PRODUCTION_WINDER_ACTUAL_SET: `${API_BASE_URL}get-actual-set-count`,

  // Sales Management

  SALES_HSN_LIST: `${API_BASE_URL}GetAllHSNLists`,
  SALES_HSN_SAVE: `${API_BASE_URL}SaveHSNMaster`,
  SALES_GET_PRICELIST: `${API_BASE_URL}GetAllPriceLists`,
  SALES_SAVE_PRICELIST: `${API_BASE_URL}SAVE_PRICELIST`,
  SALES_SAVE_PRICELIST_GSM_BREAKDOWN: `${API_BASE_URL}UpdatePriceListBreakdownList`,
  SALES_PRICELIST_GET_GSM_BREAKDOWN: `${API_BASE_URL}GetPriceListBreakdownList`,
  SALES_PRICELIST_GET_ALL_STATES: `${API_BASE_URL}GET_ALL_STATES`,
  SALES_PRICELIST_GET_ALL_DEALERS: `${API_BASE_URL}GET_ALL_DEALERS`,
  SALES_PRICELIST_GET_ALL_BASE_PRICELIST: `${API_BASE_URL}GET_ALL_BASE_PRICELIST`,
  SALES_PRICELIST_GET_ALL_QUALITIES: `${API_BASE_URL}GET_ALL_QUALITIES`,
  SALES_PRINT_PRICELIST: `${API_BASE_URL}PRINT_PRICELIST`,


  // manage holidays 
  HR_MANAGE_HOLIDAYS_LIST: `${API_BASE_URL}manage-employee-holidays`,
  HR_EXIT_EMPLOYEE_RESIGNATION_STATUS: `${API_BASE_URL}manage-employee-resignation-status`,

  //Remarks Master Get data

  MASTER_GET_REMARKS: `${API_BASE_URL}GET_MASTER_REMARKS`,
  MASTER_SAVE_REMARKS: `${API_BASE_URL}SAVE_MASTER_REMARKS`,

  //Bank Master Get data
  MASTER_GET_BANK_LIST: `${API_BASE_URL}GET_BANK_LIST`,
  MASTER_SAVE_UPDATE_BANK: `${API_BASE_URL}SAVE_UPDATE_BANK`,
  MASTER_DELETE_BANK: `${API_BASE_URL}DELETE_BANK`,
  MASTER_GET_BANK_DETAILS_BY_CODE: `${API_BASE_URL}MASTER_GET_BANK_DETAILS_BY_CODE`,

  //OverTime Master Get data

  MASTER_GET_OVERTIME_MASTER_RULES_LIST: `${API_BASE_URL}GET_OVERTIME_MASTER_RULES_LIST`,

 onduty: {
      
      list: `${API_BASE_URL}OnDuty-entry-list_getById`,
      save: `${API_BASE_URL}OnDuty-entry-list_UpdateSave`,
      expenseList:`${API_BASE_URL}Repulp-waste-type-master-list`,
       expenseSave:`${API_BASE_URL}Save-Master-Repulp-Waste-Type`,
      expenseDelete:`${API_BASE_URL}Delete-Master-Repulp-Waste-Type`,

      Approvallist: `${API_BASE_URL}OnDuty-Approval-list`,
      ApprovallistgetById: `${API_BASE_URL}OnDuty-Approval-list-By_Employee_ID`,
      Approvalupdate: `${API_BASE_URL}OnDuty-Approval-Status_Update`,
      
     },
     

};    